import React from 'react';

import { isBrandFeatureAvailable } from '@utils/get-brand-features.ts';

import { useQueryGetMe } from '@hooks/api/user/use-query-me.ts';

import { Prefooter, Banner, PromoGroup, Promo, SkinplaceBanner, Cards } from './components';
import * as Styled from './home-default.styles.ts';

const HomeDefault = () => {
	const { data: userData } = useQueryGetMe();

	const showSkinplaceBanner = isBrandFeatureAvailable('skinplace');

	if (!userData) {
		return null;
	}

	return (
		<Styled.Wrapper>
			{userData?.pm_id ? (
				<Cards />
			) : (
				<>
					<Banner />
					<Promo />
					<PromoGroup />
					{showSkinplaceBanner && <SkinplaceBanner />}
					<Prefooter />
				</>
			)}
		</Styled.Wrapper>
	);
};

export default HomeDefault;
